import { useState, useEffect } from 'react';
import Modal from './Modal';

export default function TopicModal({ isOpen, onClose, onSave, editItem = null, currentUserName }) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (editItem) {
      setText(editItem.text || '');
    } else {
      setText('');
    }
  }, [editItem, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    onSave({
      text,
      addedBy: editItem?.addedBy || currentUserName || 'Unknown'
    });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editItem ? 'Edit Topic' : 'Add Discussion Topic'}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Topic
          </label>
          <textarea
            placeholder="What do you want to discuss?"
            value={text}
            onChange={(e) => setText(e.target.value)}
            required
            rows={3}
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange resize-none"
          />
        </div>

        <div className="flex gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 px-5 bg-grey-light text-text border-none rounded-md text-sm font-medium cursor-pointer hover:bg-border"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-3 px-5 bg-orange text-white border-none rounded-md text-sm font-medium cursor-pointer hover:bg-orange-hover"
          >
            {editItem ? 'Save Changes' : 'Add Topic'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
